import React from 'react';
import classnames from 'classnames';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Flex from '@wix/da-ds/pkg/Flex';
import s from './WidgetHeaderMobile.scss';
const WidgetHeaderMobile = ({ className, isSticky, header, subHeader, count, extras, extrasWhenSticky, rootClassName, isWide = false })=>{
    const shouldRenderAsHeading = !!header;
    const Tag = shouldRenderAsHeading ? Heading : 'div';
    const renderInner = (isStuck = false)=>/*#__PURE__*/ React.createElement(Flex, {
            direction: "column",
            alignItems: "flex-start",
            className: classnames(s['root'], isStuck && s['is-stuck'], isWide && s['is-wide'], rootClassName)
        }, /*#__PURE__*/ React.createElement(Flex, {
            direction: "row",
            alignItems: "center",
            fullWidth: true,
            justifyContent: "space-between"
        }, /*#__PURE__*/ React.createElement(Tag, {
            className: s['header']
        }, header, !!count && /*#__PURE__*/ React.createElement("span", {
            className: s['count']
        }, shortenNumber(count))), extras, isStuck && extrasWhenSticky), subHeader && /*#__PURE__*/ React.createElement("div", {
            className: s['subheader']
        }, subHeader));
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['wrapper'], className)
    }, renderInner());
};
WidgetHeaderMobile.displayName = 'WidgetHeaderMobile';
export default WidgetHeaderMobile;

//# sourceMappingURL=WidgetHeaderMobile.js.map